import type { FC } from "react"

import styles from "./DatasourceConfigHeader.module.scss"

import type { StatusCounts } from "../datasourceConfigUtils"

import DatabaseIcon from "@/lib/images/DatabaseIcon"

type DatasourceConfigHeaderProps = {
	totalCount: number
	statusCounts: StatusCounts
}

const DatasourceConfigHeader: FC<DatasourceConfigHeaderProps> = ({
	totalCount,
	statusCounts,
}) => {
	return (
		<div className={styles.header}>
			<div className={styles.left}>
				<DatabaseIcon className={styles.icon} />
				<h2 className={styles.title}>媒体設定 ({totalCount}件)</h2>
			</div>
			<div className={styles.right}>
				<span className={`${styles.badge} ${styles.badgeMatch}`}>
					一致 {statusCounts.match}
				</span>
				<span className={`${styles.badge} ${styles.badgeDiff}`}>
					差分あり {statusCounts.diff}
				</span>
				<span className={`${styles.badge} ${styles.badgeUnset}`}>
					未設定 {statusCounts.unset}
				</span>
				<span className={`${styles.badge} ${styles.badgeError}`}>
					エラー {statusCounts.error}
				</span>
			</div>
		</div>
	)
}

export default DatasourceConfigHeader
